import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import baseURL from "../../config/api";

const LessonContentPage = () => {
    const { id } = useParams();
    const [content, setContent] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const res = await axios.get(`${baseURL}contents/${id}`);
                setContent(res.data);
            } catch (err) {
                console.error("Error loading content:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchContent();
    }, [id]);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-50">
                <div className="flex flex-col items-center">
                    <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-3"></div>
                    <p className="text-gray-600 font-medium">Loading content...</p>
                </div>
            </div>
        );
    }

    if (!content) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-50">
                <p className="text-gray-500 text-lg">No content found.</p>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 py-10 px-5">
            <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-2xl p-8 border border-gray-100">
                <h1 className="text-3xl font-bold text-gray-900 mb-6 border-b pb-3">
                    {content.title}
                </h1>

                <div
                    className="prose prose-lg max-w-none text-gray-800 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: content.lessonContent }}
                ></div>
            </div>
        </div>
    );
};

export default LessonContentPage;